module.exports = {
      id: "icon-arrow-down-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-arrow-down",
      toString: function () {
        return this.url;
      }
    }